/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_ChildInputs */

const fr_guardian_link_child = /** @type {(inputs: Guardian_Link_ChildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier un enfant existant`)
};

/**

* @param {Guardian_Link_ChildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_child = /** @type {((inputs?: Guardian_Link_ChildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_ChildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_child(inputs)
});